import {Column} from "../../models/secondary-nav"
import {ExcludeFrom, ExcludeFromValues} from "../../models/excludeFrom"
import {EXCLUDE_FROM_TYPE} from "../../config/constants"

export const excludeFromNarrowView = (exclude: ExcludeFromValues) => exclude === EXCLUDE_FROM_TYPE.NARROWVIEW
export const excludeFromWideView = (exclude: ExcludeFromValues) => exclude === EXCLUDE_FROM_TYPE.WIDEVIEW

interface ExcludableItem {
    excludeFrom?: ExcludeFrom
}
export const filterByExcludeFrom = (showAsWideView: boolean) => (item: ExcludableItem) =>
    !item.excludeFrom ||
    (showAsWideView && !item.excludeFrom.some(excludeFromWideView)) ||
    (!showAsWideView && !item.excludeFrom.some(excludeFromNarrowView))

export const filterColumnsByExcludeFrom = (showAsWideView: boolean, columns: Column[]) =>
    columns
        ? columns.filter(filterByExcludeFrom(showAsWideView)).map(column => ({
              ...column,
              items: column.items.filter(filterByExcludeFrom(showAsWideView)).map(category => ({
                  ...category,
                  items: category.items.filter(filterByExcludeFrom(showAsWideView)),
              })),
          }))
        : []
